import T from 'i18n-react'
import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc,
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => {
  let items = Object.keys(state.properties.values.items.properties)
  let values = state.values
  return items.map((item) => {
    let curr = values.find((val) => val.value === item)
    return {
      'disabled': curr ? curr.disabled : false, 
      'itemLabel': T.translate(`notebook_project_creation.extra_features.${item}`),
      'value': item,
      'label': curr ? curr.label : 'No'
    }
  })
}
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''
const getValueSelector = (path, id) => createSelectorWithPath(`${path}.${id}`, valuesSelectorFunc)
export {
  getValueSelector
}

export default (path) => {
  const selectorWithPath = createSelectorWithPath(path)
  const valueSelector = selectorWithPath(valuesSelectorFunc)
  const hintSelector = selectorWithPath(hintSelectorFunc)
  const labelSelector = selectorWithPath(labelSelectorFunc)

  return {
    valueSelector,
    hintSelector,
    labelSelector
  }
}
